import type { CrmHistoryEventMap } from '@/Containers/CrmSection/Components/History'

/**
 * Коди подій історії клієнта — рівно enum беку
 * `backend/web/src/Containers/ClientContainer/Database/Enum/ClientHistoryEvent.php`
 * (`SPEC-009` §4.9): по коду на кожен суфікс ядра CRM `CrmHistoryEvent`.
 *
 * Ключі — **буквальні** повні коди: мапу звіряє з беком вартовий «кожен код
 * події історії з бека має підпис на фронті»
 * (`Ship/Helpers/architectureGuard.test.ts`). Стрічка малює `label ?? event`,
 * тож код без підпису витік би користувачу голим.
 *
 * Підписи й тони — `SPEC-008` §5.5: кольорові лише події, що міняють стан
 * клієнта; правки, діти й файли — нейтральні.
 */
export const CLIENT_HISTORY_EVENT_MAP: CrmHistoryEventMap = {
    client_created: { label: 'Створено', tone: 'blue', kind: 'created' },
    client_updated: { label: 'Змінено дані', tone: 'neutral', kind: 'updated' },
    client_removed: { label: 'Видалено', tone: 'red', kind: 'removed' },
    client_status_changed: { label: 'Змінено статус', tone: 'purple', kind: 'status' },
    client_verification_sent: { label: 'Відправлено на верифікацію', tone: 'geekblue', kind: 'status' },
    client_verified: { label: 'Верифікацію підтверджено', tone: 'green', kind: 'status' },
    client_verification_rejected: { label: 'Верифікацію відхилено', tone: 'orange', kind: 'status' },
    client_blacklisted: { label: 'Додано до чорного списку', tone: 'red', kind: 'status' },
    client_unblacklisted: { label: 'Видалено з чорного списку', tone: 'green', kind: 'status' },
    client_contact_added: { label: 'Додано контакт', tone: 'neutral', kind: 'contact' },
    client_contact_updated: { label: 'Змінено контакт', tone: 'neutral', kind: 'contact' },
    client_contact_removed: { label: 'Видалено контакт', tone: 'neutral', kind: 'contact' },
    client_contract_added: { label: 'Додано договір', tone: 'neutral', kind: 'contract' },
    client_contract_updated: { label: 'Змінено договір', tone: 'neutral', kind: 'contract' },
    client_contract_removed: { label: 'Видалено договір', tone: 'neutral', kind: 'contract' },
    client_document_added: { label: 'Додано документ', tone: 'neutral', kind: 'document' },
    client_document_updated: { label: 'Змінено документ', tone: 'neutral', kind: 'document' },
    client_document_removed: { label: 'Видалено документ', tone: 'neutral', kind: 'document' },
    client_document_generated: { label: 'Згенеровано документ', tone: 'neutral', kind: 'document' },
    client_document_edited: { label: 'Документ змінено в редакторі', tone: 'neutral', kind: 'document' },
    client_file_attached: { label: 'Прикріплено файл', tone: 'neutral', kind: 'file' },
    client_file_removed: { label: 'Видалено файл', tone: 'neutral', kind: 'file' },
}
